import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";

type State = {
  status: number;
  pesquisa: string | Date | null;
  situacao: number;
  NomeDocumento: string | null;
  DataDe: Date | null,
  DataAte: Date | null,
};

type Actions = {
  setStatus: SetFunction<number>;
  setPesquisa: SetFunction<string | Date | null>;
  setSituacao: SetFunction<number>;
  setDataDe: SetFunction<Date | null>,
  setDataAte: SetFunction<Date | null>,
  setNomeDocumento: SetFunction<string | null>;
  clearFilters: () => void;
};

export const initialFiltersValues: State = {
  status: 0,
  pesquisa: null,
  situacao: 2,
  NomeDocumento: null,
  DataDe:  null,
  DataAte: null,
};

export const useDocumentoFilters = create<State & Actions>((set) => ({
  ...initialFiltersValues,
  setStatus: (vfn) => SetFunctionImpl(set, "status", vfn),
  setPesquisa: (vfn) => SetFunctionImpl(set, "pesquisa", vfn),
  setSituacao: (vfn) => SetFunctionImpl(set, "situacao", vfn),
  setDataDe: (vfn) => SetFunctionImpl(set, "DataDe", vfn),
  setDataAte: (vfn) => SetFunctionImpl(set, "DataAte", vfn),
  setNomeDocumento: (vfn) => SetFunctionImpl(set, "NomeDocumento", vfn),
  clearFilters: () => set((state) => ({
    ...initialFiltersValues,
  })),
}));
 